<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-md modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h4 class="mb-0">Employee Offboarding Recommendation</h4>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2">
                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo"> <span class="required">*</span> Recommended </label>
                        <v-select
                            placeholder="Select Type"
                            v-model="recommendationType"
                            :options="recommendationTypeList"
                            label="name"
                            :reduce="name => name.value"
                        />
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo"> <span class="required">*</span> Last Working Date </label>
                        <input
                            class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                            tabindex="1"
                            type="date"
                            placeholder=""
                            v-model="formData.last_working_date"
                        >
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="row">
                        <div class="col-9">
                          <label for="colFormLabel" class="col-form-label">Clearance Employee</label>
                          <AsyncSelect
                              placeholder="Employee"
                              v-model="contactProfile"
                              :api-service="fetchContactProfiles"
                              :additional-query="{roles: 'employee', status: 'active'}"
                              label="name"
                          />
                        </div>
                        <div class="col-3">
                          <button type="button" class="btn btn-primary btn-sm ms-2 mt-3" @click="addEmployee">
                            <i class="fa fa-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div v-if="clearanceEmployees.length" class="col-12 mt-2">
                      <ul class="list-group">
                        <li v-for="emp in clearanceEmployees" :key="emp.id" class="list-group-item d-flex justify-content-between align-items-center">
                          {{ emp.name }}
                          <button v-if="emp.status == 'pending'" type="button" class="btn btn-danger btn-sm" @click="removeEmployee(emp.id)">
                            <i class="fa fa-trash"></i>
                          </button>
                        </li>
                      </ul>
                    </div>

                    <div class="col-6 text-center mb-2 mt-2">
                      <button :disabled="loading" @click="submit" type="button" class="btn btn-primary full-width me-1 waves-effect waves-float waves-light">
                        <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        Submit
                      </button>
                    </div>
                    </div>
                 </div>
            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {inject, onMounted, ref, watch} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import handleContact from "@/services/modules/contact";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import handleChartAccount from '@/services/modules/chartAccount'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";

const props = defineProps({
    formData:{
      type:Object,
      default:{}
    }
});

const emit = defineEmits(['getOffBoardingList']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const recommendationType = ref('');
const recommendationTypeList = ref([]);
const isEdit = ref(false);
const clearanceEmployees = ref([]);
const contactProfile = ref(null);
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');

const {
  fetchTypes,
  createEmployeeOffBoardingRecommended
} = handleHrPayroll()
const { fetchContactProfiles } = handleContact();
const { fetchHome } = handleChartAccount()

const addEmployee = () => {
  if (!contactProfile.value) {
    showError('Please select an employee');
    return;
  }

  const exists = clearanceEmployees.value.find(e => e.id === contactProfile.value.id);
  if (exists) {
    showError('This employee is already added');
    return;
  }

  clearanceEmployees.value.push({
    id: contactProfile.value.id,
    name: contactProfile.value.name,
    status: 'pending'
  });
  contactProfile.value = null;
};

const removeEmployee = (id) => {
  clearanceEmployees.value = clearanceEmployees.value.filter(e => e.id !== id);
};

const submit = async () => {
  if (!clearanceEmployees.value.length) {
    showError('Please select at least one employee');
    return;
  }

  if (! recommendationType.value){
    showError('Please select recommendation type');
    return;
  }

  loading.value = true;
  let offBoardingData = {};
  offBoardingData.employee_off_boarding_id = props.formData.employee_off_boarding_id;
  offBoardingData.last_working_date = props.formData.last_working_date;
  offBoardingData.recommendation_type = recommendationType.value ? recommendationType.value : null;
  offBoardingData.contact_profile_ids = clearanceEmployees.value.map(e => e.id)

  let query = getQuery()
  await createEmployeeOffBoardingRecommended(offBoardingData, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit("getOffBoardingList");
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const onClickClose = () => {
    $store.state.isModalOpenTwo = false;
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

watch(() => props.formData, (newVal) => {
  if (newVal.recommendation_type) {
     recommendationType.value = newVal.recommendation_type
  }
  if (newVal.contact_profile && newVal.contact_profile.length){
    clearanceEmployees.value = [];
    newVal.contact_profile.forEach(employee => {
      clearanceEmployees.value.push({
        id: employee.contact_profile_id,
        name: employee.employee_name,
        status: employee.status
      });
    });
  }
}, { immediate: true, deep: true })

onMounted(() => {
  Promise.all([
    fetchHome().then(res => {
      if (!res.data) {
        return;
      }
      if (res.data && res.data.recommendation_type){
        recommendationTypeList.value = res.data.recommendation_type;
      }
    })
  ])
})

</script>
